<div class="about-page">
    <app-landing-toolbar></app-landing-toolbar>

    <!-- HERO SECTION -->
    <header class="hero-section">
        <div class="hero-content">
            <span class="hero-badge">Workbi Services S.A.S.</span>
            <h1 class="hero-title">Ingeniería de Software & Soluciones Digitales</h1>
            <p class="hero-subtitle">
                Transformamos ideas en productos digitales de alto valor. Somos una empresa especializada en desarrollo
                de software, arquitectura digital y creadores de la plataforma <strong>Workbi</strong>.
            </p>
        </div>
    </header>

    <main class="main-container">

        <!-- SECCIÓN 1: QUIÉNES SOMOS -->
        <section class="section company-section">
            <div class="section-header">
                <span class="section-tag">Conócenos</span>
                <h2>¿Quiénes Somos?</h2>
            </div>

            <div class="company-card">
                <div class="company-desc">
                    <p>
                        <b>Workbi Services S.A.S.</b> es una empresa colombiana especializada en el diseño, desarrollo e
                        implementación de soluciones tecnológicas avanzadas. Nos apasiona la creación de software
                        robusto, intuitivo y escalable que responde a los retos del mercado digital actual.
                    </p>
                    <p>
                        Acompañamos a nuestros clientes en todo el ciclo de vida del producto: desde la
                        conceptualización y diseño de experiencia de usuario (UX/UI), hasta la arquitectura en la nube,
                        integración de pasarelas de pago y soporte operativo continuo.
                    </p>
                </div>

                <div class="company-facts">
                    <div class="fact-item">
                        <mat-icon class="fact-icon">business</mat-icon>
                        <div>
                            <span class="fact-label">Razón Social</span>
                            <span class="fact-value">Workbi Services S.A.S.</span>
                        </div>
                    </div>

                    <div class="fact-item">
                        <mat-icon class="fact-icon">verified_user</mat-icon>
                        <div>
                            <span class="fact-label">NIT</span>
                            <span class="fact-value">901.812.872-9</span>
                        </div>
                    </div>

                    <div class="fact-item">
                        <mat-icon class="fact-icon">location_on</mat-icon>
                        <div>
                            <span class="fact-label">Sede</span>
                            <span class="fact-value">Bogotá D.C., Colombia</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- SECCIÓN 2: PORTAFOLIO WORKBI -->
        <section class="section portfolio-section">
            <div class="portfolio-banner">
                <div class="portfolio-header">
                    <span class="badge-gold">NUESTRO PORTAFOLIO Y PRODUCTO INSIGNIA</span>
                    <h2>Workbi – Plataforma Digital de Servicios</h2>
                    <p class="portfolio-intro">
                        Nuestro portafolio de productos empieza con <b>Workbi</b>, una plataforma tecnológica
                        desarrollada e impulsada íntegramente por nuestro equipo. Workbi conecta a usuarios que
                        requieren servicios con profesionales y especialistas capacitados (<i>Workbies</i>).
                    </p>
                </div>

                <div class="portfolio-features-grid">
                    <div class="feature-card" *ngFor="let item of portfolioHighlights">
                        <mat-icon class="feature-check">check_circle</mat-icon>
                        <span>{{ item }}</span>
                    </div>
                </div>

                <p class="portfolio-footer-note">
                    <b>Workbi</b> demuestra nuestra sólida capacidad técnica en el desarrollo de aplicaciones móviles
                    (iOS y Android), sistemas web, integraciones transaccionales y pasarelas de pago.
                </p>
            </div>
        </section>

        <!-- SECCIÓN 3: SERVICIOS DE DESARROLLO -->
        <section class="section services-section">
            <div class="section-header">
                <span class="section-tag">Capacidades</span>
                <h2>Nuestros Servicios de Desarrollo</h2>
                <p class="section-sub">Ofrecemos soluciones tecnológicas integrales adaptadas a las exigencias de tu
                    empresa:</p>
            </div>

            <div class="services-grid">
                <div class="service-card" *ngFor="let service of services">
                    <div class="service-icon-box">
                        <mat-icon>{{ service.icon }}</mat-icon>
                    </div>
                    <h3>{{ service.title }}</h3>
                    <p>{{ service.description }}</p>
                </div>
            </div>
        </section>

        <!-- SECCIÓN 4: MISIÓN Y VISIÓN -->
        <section class="section mv-section">
            <div class="mv-grid">
                <div class="mv-card mission">
                    <div class="mv-icon-wrap">
                        <mat-icon>flag</mat-icon>
                    </div>
                    <h3>Misión</h3>
                    <p>
                        Diseñar, desarrollar y escalar soluciones tecnológicas de alta calidad que generen valor real
                        para las empresas y usuarios, impulsando la transformación digital a través de la excelencia
                        técnica, la innovación y la seguridad.
                    </p>
                </div>

                <div class="mv-card vision">
                    <div class="mv-icon-wrap">
                        <mat-icon>visibility</mat-icon>
                    </div>
                    <h3>Visión</h3>
                    <p>
                        Consolidarnos como una firma referente en el desarrollo de software y plataformas digitales
                        escalables en la región, reconocida por la calidad, innovación tecnológica e impacto positivo de
                        nuestros productos como Workbi.
                    </p>
                </div>
            </div>
        </section>

        <!-- SECCIÓN 5: CONTACTO -->
        <section class="section contact-section">
            <div class="contact-card">
                <div class="contact-info">
                    <h2>¿Tienes algún proyecto o consulta?</h2>
                    <p>Estamos listos para colaborar contigo o resolver cualquier inquietud.</p>
                </div>
                <div class="contact-links">
                    <a [href]="'mailto:' + contactMail" class="contact-btn primary">
                        <mat-icon>mail</mat-icon>
                        <span>{{ contactMail }}</span>
                    </a>
                    <a [href]="'mailto:' + mail" class="contact-btn secondary">
                        <mat-icon>support_agent</mat-icon>
                        <span>PQRS: {{ mail }}</span>
                    </a>
                </div>
            </div>
        </section>

    </main>

    <app-landing-footer></app-landing-footer>
</div>